import { OcrResult } from "@finway-group/shared/lib/models"
import { roundNumberTo2Decimals } from "@finway-group/shared/lib/utils"
import { Col, Row } from "antd"
import React from "react"
import i18n from "~Shared/locales/i18n"
import { SectionHeader, SummaryRow } from "./shared"

interface SummaryProps {
    data: OcrResult
}

export const EInvoiceSummary = ({ data }: SummaryProps) => {
    if (!data.eInvoiceData?.totals) {
        return null
    }

    const { totals } = data.eInvoiceData

    return (
        <>
            <SectionHeader title={i18n.t("label:invoice_summary")} />
            <SummaryRow label={i18n.t("label:total_item_amount")} value={`${roundNumberTo2Decimals(totals.lineAmount)} EUR`} />
            <SummaryRow label={i18n.t("label:total_surcharges")} value={`${roundNumberTo2Decimals(totals.chargeAmount)} EUR`} />
            <SummaryRow label={i18n.t("label:total_discounts")} value={`${roundNumberTo2Decimals(totals.allowanceAmount)} EUR`} />
            <SummaryRow label={i18n.t("label:subtotal_net_amount")} value={`${roundNumberTo2Decimals(totals.taxExclusiveAmount)} EUR`} isBold />
            <SummaryRow label={i18n.t("label:total_vat_amount")} value={`${roundNumberTo2Decimals(totals.taxAmount)} EUR`} />
            <SummaryRow label={i18n.t("label:subtotal_gross_amount")} value={`${roundNumberTo2Decimals(totals.taxInclusiveAmount)} EUR`} isBold />
            <SummaryRow label={i18n.t("label:advance_payments")} value={`${roundNumberTo2Decimals(totals.prepaidAmount)} EUR`} />
            <Row className="p-4 text-xs">
                <Col span={12}>
                    <span className="font-medium text-black">{i18n.t("label:amount_due")}</span>
                </Col>
                <Col span={12} className="text-right font-medium text-black">
                    <span>{roundNumberTo2Decimals(totals.payableAmount)} EUR</span>
                </Col>
            </Row>
        </>
    )
}
